export default {"src":"/_next/static/media/diamond.724779d2.svg","height":16,"width":17};